import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CatalogComponent} from './catalog/catalog.component';
import {CoursesComponent} from './courses/courses.component';
import {HomeRoutingModule} from './home-routing.module';
import {LearnComponent} from './learn/learn.component';
import {CourseCardComponent} from '../components/course-card/course-card.component';
import {CourseGroupCardComponent} from '../components/course-group-card/course-group-card.component';

import {FeedCardComponent} from '../components/feed-card/feed-card.component';
import {MarketingCardComponent} from '../components/marketing-card/marketing-card.component';
import {FavoriteFilterPipe} from './favorite-filter.pipe';
import {FeedsComponent} from './feeds/feeds.component';
import {LibraryComponent} from './library/library.component';
import {JwplayerDirective} from '../jwplayer.directive';
import {VideojsDirective} from '../videojs.directive';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {ComponentModule} from '../components/component.module';
import {InvitationAcceptanceComponent} from './invitation-acceptance/invitation-acceptance.component';
import {ConnectionAcceptanceComponent} from './connection-acceptance/connection-acceptance.component';
import {PipeModule} from '../pipes/pipes.module';
import {TokenClaimComponent} from './token-claim/token-claim.component';
import {MagicLinkFailureComponent} from './magic-link-failure/magic-link-failure.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LearnToFlyComponent} from './learn-to-fly/learn-to-fly.component';
import {AboutCourseModalComponent} from './about-course-modal/about-course-modal.component';
import {StartAssessmentModalComponent} from './start-assessment-modal/start-assessment-modal.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DiscoverComponent} from './discover/discover.component';
import {DiscoverCoursesComponent} from '../components/discover-courses/discover-courses.component';
import {DocumentContainerComponent} from './document/document-container.component';
import {LearnFreeCoursesComponent} from './learn-free-courses/learn-free-courses.component';
import {PilotTrainingPlusComponent} from './pilot-training-plus/pilot-training-plus.component';
import { BannerIconComponent } from './discover/banner-icon/banner-icon.component';
import { IfrVfrMasteryBannerComponent } from './discover/ifr-vfr-mastery-banner/ifr-vfr-mastery-banner.component';
import { PilotTrainingBannerComponent } from './discover/pilot-training-banner/pilot-training-banner.component';
import { YoungEaglesVoucherRedeemptionComponent } from './young-eagles-voucher-redeemption/young-eagles-voucher-redeemption.component';

@NgModule({
  declarations: [
    CatalogComponent,
    CoursesComponent,
    LearnComponent,
    CourseCardComponent,
    FavoriteFilterPipe,
    FeedCardComponent,
    MarketingCardComponent,
    FeedsComponent,
    LibraryComponent,
    CourseGroupCardComponent,
    JwplayerDirective,
    VideojsDirective,
    InvitationAcceptanceComponent,
    ConnectionAcceptanceComponent,
    TokenClaimComponent,
    LearnToFlyComponent,
    YoungEaglesVoucherRedeemptionComponent,
    AboutCourseModalComponent,
    StartAssessmentModalComponent,
    DiscoverComponent,
    DiscoverCoursesComponent,
    MagicLinkFailureComponent,
    DocumentContainerComponent,
    LearnFreeCoursesComponent,
    PilotTrainingPlusComponent
  ],

  imports: [
    CommonModule,
    HomeRoutingModule,
    BsDropdownModule,
    ComponentModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
    IfrVfrMasteryBannerComponent,
    PilotTrainingBannerComponent,
    BannerIconComponent
  ],
  exports: [
    JwplayerDirective
  ],
  providers: [
    BsModalRef
  ]
})
export class HomeModule {
}
